<template>
  <div class="mine-content">
    <!-- <m-loading :loading="pageLoading"></m-loading> -->
    <MineHead :infos="infos" @open-role-detail="openDetail" />
    <div class="more-service">
      <div class="service-list">
        <img :src="item.img" alt="" :class="['service-item', item.id]" v-for="(item, i) in roleServiceList" :key="i"
          @click="serviceClick(item)" />
        <!-- <div :class="['service-item', item.id]" v-for="(item, i) in roleServiceList" :key="i" @click="serviceClick(item)">
          <img :src="item.img" alt="" />
          <p>{{ item.name }}</p>
        </div> -->
      </div>
    </div>
    <van-action-sheet v-model="linkShow" cancel-text="取消" close-on-click-action :actions="[
      { name: '复制客服微信号', type: 0, content: wechatId },
      { name: '复制客服热线电话', type: 1, content: hotLine }
    ]" @select="onSelect" />
  </div>
</template>

<script>
import { signature } from "@/utils/mixin/wx-js-sdk-signature";
import { formatNumber, queryObj } from "@/utils/tool";
import MineHead from "@/components/mine/MineHead.vue";
import { getJudgesHotLine } from "@/utils/api/judge";
import { personalData } from "@/utils/api/user";
export default {
  mixins: [signature],
  components: {
    MineHead
  },
  data() {
    return {
      pageLoading: true,
      infos: {},
      powers: 0,
      linkShow: false,
      allService: [
        // {
        //   name: "报名服务单位",
        //   id: "training",
        //   powers: [0],
        //   img: require("../../assets/images/mine/fuwudanwei.png"),
        //   path: ""
        // },
        {
          name: "学生管理",
          id: "baby",
          powers: [0],
          img: require("../../assets/images/mine/xueshengguanli.png"),
          path: ""
        },
        {
          name: "点评记录",
          id: "record",
          powers: [1],
          img: require("../../assets/images/mine/remark-ico.png"),
          path: ""
        },
        {
          name: "联系客服",
          id: "service",
          powers: [1],
          img: require("../../assets/images/mine/servicer-ico.png"),
          path: ""
        },
        {
          name: "关于我们",
          id: "about",
          powers: [0, 1, 2, 3],
          img: require("../../assets/images/mine/guanyuwomen.png"),
          path: ""
        },
        {
          name: "设置",
          id: "setting",
          powers: [0, 1, 2, 3],
          img: require("../../assets/images/mine/shezhi.png"),
          path: ""
        },
        {
          name: "扫一扫",
          id: "codeConfirm",
          powers: [0, 1, 2, 3],
          img: require("../../assets/images/mine/saiyisao.png"),
          path: ""
        },
        {
          name: "我的反馈",
          id: "fankui",
          powers: [0, 1, 2, 3],
          img: require("../../assets/images/mine/fankui.png"),
          path: ""
        },
        {
          name: "我的订单",
          id: "order",
          powers: [0],
          img: require("../../assets/images/mine/myOrder.png"),
          path: ""
        }
        // {
        //   name: "清除缓存",
        //   id: "clear",
        //   powers: [0, 1, 2, 3],
        //   img: require("../../assets/images/mine/setting-ico.png"),
        //   path: ""
        // }
      ],
      roleServiceList: [],
      wechatId: null,
      hotLine: null,
      // 注册页面扫码功能
      jsApiList: ["scanQRCode"]
    };
  },
  methods: {
    // 编辑详细信息
    openDetail() {
      this.$router.push("/mine/editinfo");
    },
    // 获取当前用户信息
    async getRoleInfos() {
      const { data: attach } = await personalData();
      const infos = this.$store.state.userInfo,
        role = this.$store.state.role,
        roleStr = role === 0 ? "个人" : role === 1 ? "评委" : role === 2 ? "报名服务单位" : "赛事组织单位",
        subjoin =
          role === 0
            ? [
              {
                val: formatNumber(attach.worksNum),
                lab: "作品"
              },
              {
                val: formatNumber(attach.likeNum),
                lab: "获赞"
              }
            ]
            : role === 1
              ? [
                {
                  val: attach.totalCommentNum || 0,
                  lab: "点评次数"
                },
                {
                  val: attach.average || 0,
                  lab: "历史平均打分"
                }
              ]
              : role === 2
                ? [
                  {
                    val: attach.studentWorksNum || 0,
                    lab: "学生作品"
                  },
                  {
                    val: attach.studentNum || 0,
                    lab: "学生数量"
                  }
                ]
                : [
                  {
                    val: attach.institutionNum || 0,
                    lab: "报名服务单位数"
                  },
                  {
                    val: attach.babyNum || 0,
                    lab: "选手数"
                  }
                ];
      if (role === 1) this.getExpertHotLine();
      this.infos = {
        img: infos.userImg,
        name: infos.nickName,
        isVip: false,
        role,
        roleStr,
        subjoin
      };
      this.pageLoading = false;
    },
    // 根据权限显示服务
    showServiceByPower() {
      this.powers = this.$store.state.role;
      this.roleServiceList = this.allService.filter((e) => {
        return e.powers.includes(this.powers);
      });
    },
    // 服务点击
    serviceClick(item) {
      const way = item.id;
      switch (way) {
        case "training":
          //
          // this.$router.push("/player/organization");
          this.$root.mipLink("/player/organization");
          break;
        case "baby":
          this.$router.push("/player/mybaby");
          break;
        case "about":
          this.$router.push("/mine/about");
          break;
        case "setting":
          this.$router.push("/mine/setting");
          break;
        case "record":
          this.$router.push("/judge/remarkrecord");
          break;
        case "clear":
          window.sessionStorage.clear();
          window.localStorage.clear();
          window.location.reload();
          break;
        case "codeConfirm":
          this.getcodeConfirm()
          break;
        case "service":
          this.linkShow = true;
          break;
        case "fankui":
          this.$router.push("/mine/feedbackList");
          break;
        case "order":
          this.$router.push("/cert");
          break;
        default:
          break;
      }
    },
    /**
     * @description: 调用微信扫一扫
     * @param {*}
     * @return {*}
     * @author: wangxiaoheng
     */
    getcodeConfirm() {
      const userInfo = this.$store.state.userInfo;
      let isLogin = JSON.stringify(userInfo) !== "{}";
      if (!isLogin) {
        this.$root.$toast.fail("请先登录");
        return;
      }
      /* eslint-disable */
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: (res) => {
            // 绑定报名服务单位
            if (res && res.resultStr) {
              let data = queryObj(res.resultStr)
              if(data.activityId&&data.action&&data.registerCode){
                this.$router.push({
                  path: '/mine/codeConfirm',
                  query: {
                    registerCode: data.registerCode,
                    action: data.action,
                    activityId: data.activityId,
                  }
                });
              }else{
                this.$root.$toast.fail("二维码有误，请尝试更换二维码扫描");
              }
            }
          },
          fail: (err) => {
            const followed = err.errMsg.indexOf(
              "the permission value is offline verifying"
            );
            if (followed > 0) {
              this.$notify({
                type: "danger",
                message: "请检查是否关注该公众号"
              });
              this.$root.$toast.fail({
                message: "获取页面权限失败，请刷新页面后重试！",
                duration: 2000,
                onClose: () => {
                  this.refreshJSToken();
                }
              });
            } else {
              this.$root.$toast.fail({
                message: JSON.stringify(err),
                duration: 2000,
                onClose: () => {
                  this.refreshJSToken();
                }
              });
            }
          }
        });
      });
    },
    //
    onSelect(item) {
      const text = item.content;
      let input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.style.position = "absolute";
      input.style.opacity = 0;
      input.style.zIndex = "-1";
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$root.$toast.success("复制成功！");
      }
      document.body.removeChild(input);
    },
    // 评委单获取微信号/服务热线
    getExpertHotLine() {
      getJudgesHotLine().then((res) => {
        if (res.success) {
          this.wechatId = res.data[1].keyValue || "null value";
          this.hotLine = res.data[2].keyValue || "null value";
        }
      });
    }
  },
  mounted() {
    this.getRoleInfos();
    this.showServiceByPower();
  }
};
</script>
<style lang="scss">
.mine-content {
  height: 100%;
  background-image: url("../../assets/images/mine/mine-back.png");
  background-size: 100% 100%;

  .more-service {
    margin-top: 24px;
    padding: 0 20px;
    width: 100%;
  }

  .service-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .service-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 92px;
      height: 90px;
      border-radius: 8px;
      margin-right: calc((100% - 276px) / 2);

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:nth-child(n + 4) {
        margin-top: 13px;
      }

      &.training,
      &.record {
        background-color: #fefaf2;
      }

      &.baby,
      &.service {
        background-color: #eff9f7;
      }

      &.about {
        background-color: #fdf4f4;
      }

      &.setting {
        background-color: #f2fbfe;
      }

      &.codeConfirm {
        background-color: #FEF5F9;
      }

      img {
        width: 27px;
        height: 27px;
      }

      p {
        font-size: 12px;
        color: #666;
        margin-top: 22px;
      }
    }
  }
}
</style>
